<template>
  <div id="custom-table-list" class="custom-table-container">
    <subscriber-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :subscriber="sidebarData"
    />

    <subscriber-view-sidebar
      v-else
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />

    <vs-table
      ref="table"
      multiple
      :sst="true"
      @sort="handleSort"
      @search="handleSearch"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      search
      :data="subscribers"
    >
      <!-- HEADER -->
      <div slot="header" id="custom-header-wrapper">
        <HeaderList
          :itemsPerPage="itemsPerPage"
          @changeItemsPerPage="setItemsPerPage"
          @emitAddNewData="addNewData"
        />
      </div>
      <!-- FIM HEADER -->

      <template slot="thead">
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="first_name">Nome</vs-th>
        <vs-th sort-key="last_name">Sobrenome</vs-th>
        <vs-th>Celular</vs-th>
        <vs-th>Assinou Em</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <p class="product-name font-medium">{{ tr.email }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">{{ tr.first_name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">{{ tr.last_name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">{{ tr.phone_number }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium">
                {{ formatStringDate(tr.created_at) }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
  import SubscriberViewSidebar from './SubscriberViewSidebar'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleSubscriber from '@/store/newsletter/subscriber/moduleSubscriber'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'subscribers-list',
    components: {
      SubscriberViewSidebar,
      HeaderList
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        searchField: null,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        }
      }
    },
    computed: {
      subscribers() {
        return this.$store.state.newsletterSubscriber.subscribers
      },
      totalPages() {
        return this.$store.state.newsletterSubscriber.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      deleteData(subscriberId) {
        this.$store.dispatch("newsletterSubscriber/delete", subscriberId)
          .catch(err => { console.error(err) })
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            email: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleSubscriber.isRegistered) {
          this.$store.dispatch("newsletterSubscriber/fetch", {
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleSubscriber.isRegistered) {
        this.$store.registerModule('newsletterSubscriber', moduleSubscriber)
        moduleSubscriber.isRegistered = true
      }
      
      this.fetchData();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>